import { useEffect, useState } from "react";
import { AccessControlAPI } from "../../api/accessControl";

export default function AccessControlJobsPage() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadJobs() {
    try {
      setLoading(true);
      setError("");

      const data = await AccessControlAPI.listJobs();
      setJobs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load access control jobs", err);
      setError("Failed to load access control jobs");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadJobs();
  }, []);

  return (
    <div className="p-6 space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">Access Control Jobs</h1>
        <p className="text-sm text-gray-600">
          View Net2 access control jobs sent from Nightjar.
        </p>
      </div>

      {error && (
        <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="rounded border bg-white">
        <div className="flex items-center justify-between border-b p-3">
          <h2 className="font-medium">Recent Jobs</h2>
          <button
            type="button"
            onClick={loadJobs}
            className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
          >
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="p-4 text-sm text-gray-600">Loading...</div>
        ) : jobs.length === 0 ? (
          <div className="p-4 text-sm text-gray-600">
            No access control jobs found.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="border-b bg-gray-50">
                <tr>
                  <th className="p-3">ID</th>
                  <th className="p-3">School</th>
                  <th className="p-3">System</th>
                  <th className="p-3">Action</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Payload</th>
                  <th className="p-3">Response</th>
                  <th className="p-3">Created</th>
                  <th className="p-3">Error</th>
                </tr>
              </thead>

              <tbody>
                {jobs.map((job) => (
                  <tr key={job.id} className="border-b align-top">
                    <td className="p-3">{job.id}</td>

                    <td className="p-3">
                      {job.school_name || job.school_id}
                    </td>

                    <td className="p-3">
                      {job.system_name || job.system_id || "-"}
                    </td>

                    <td className="p-3">{job.action}</td>

                    <td className="p-3">
                      <span
                        className={`rounded px-2 py-1 text-xs ${
                          job.status === "success"
                            ? "bg-green-100 text-green-700"
                            : job.status === "failed"
                            ? "bg-red-100 text-red-700"
                            : job.status === "sent"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-gray-100 text-gray-700"
                        }`}
                      >
                        {job.status}
                      </span>
                    </td>

                    <td className="p-3">
                      <pre className="max-w-xs overflow-auto rounded bg-gray-50 p-2 text-xs">
                        {JSON.stringify(job.payload, null, 2)}
                      </pre>
                    </td>

                    <td className="p-3">
                      <pre className="max-w-xs overflow-auto rounded bg-gray-50 p-2 text-xs">
                        {job.response ? JSON.stringify(job.response, null, 2) : "-"}
                      </pre>
                    </td>

                    <td className="p-3">
                      {job.created_at
                        ? new Date(job.created_at).toLocaleString()
                        : "-"}
                    </td>

                    <td className="p-3 text-red-700">
                      {job.error || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}